/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Site_CommanderInputs */

const en_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site Commander`)
};

const es_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comandante del sitio`)
};

const fr_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site Commander`)
};

const de_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site Commander`)
};

const ja_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイトコマンダー`)
};

const zh_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`站点指挥官`)
};

const ar_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مدير الموقع`)
};

const id_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komandan Situs`)
};

const it_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestione Sito`)
};

const ru_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление сайтом`)
};

const pt_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comandante do Site`)
};

const ko_site_commander = /** @type {(inputs: Site_CommanderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사이트 커맨더`)
};

/**
* | output |
* | --- |
* | "Site Commander" |
*
* @param {Site_CommanderInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const site_commander = /** @type {((inputs?: Site_CommanderInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Site_CommanderInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_site_commander(inputs)
	if (locale === "es") return es_site_commander(inputs)
	if (locale === "fr") return fr_site_commander(inputs)
	if (locale === "de") return de_site_commander(inputs)
	if (locale === "ja") return ja_site_commander(inputs)
	if (locale === "zh") return zh_site_commander(inputs)
	if (locale === "ar") return ar_site_commander(inputs)
	if (locale === "id") return id_site_commander(inputs)
	if (locale === "it") return it_site_commander(inputs)
	if (locale === "ru") return ru_site_commander(inputs)
	if (locale === "pt") return pt_site_commander(inputs)
	return ko_site_commander(inputs)
});